/* CUSTOM (Shopify-Session)
 * gallery-thumb-aspect.js — Galerie-Thumbnails folgen dem echten Bild-Aspect
 * statt fix 1:1. Origin rendert Thumbnails als direkten <img>; wir lesen
 * width/height bzw. naturalWidth/naturalHeight und setzen --thumb-ratio aufs
 * <li>. custom.css macht daraus padding-bottom.
 *
 * Läuft initial + nach DOM-Änderungen (z.B. nach AJAX-Tausch durch glaze-picker).
 */
(function () {
  function ratioFromImg(img) {
    if (img.naturalWidth && img.naturalHeight) {
      return img.naturalWidth / img.naturalHeight;
    }
    var w = parseFloat(img.getAttribute('width'));
    var h = parseFloat(img.getAttribute('height'));
    if (w && h) return w / h;
    return null;
  }

  function setOnItem(item) {
    if (item.style.getPropertyValue('--thumb-ratio')) return;
    var img = item.querySelector('img');
    if (!img) return;
    var r = ratioFromImg(img);
    if (r) {
      item.style.setProperty('--thumb-ratio', r);
    } else {
      img.addEventListener('load', function () {
        var r2 = ratioFromImg(img);
        if (r2) item.style.setProperty('--thumb-ratio', r2);
      }, { once: true });
    }
  }

  function apply(root) {
    (root || document).querySelectorAll('.thumbnail-list__item').forEach(setOnItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(); });
  } else {
    apply();
  }

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) apply(added[j]);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
